import React from 'react'

import { StyleSheet, Keyboard, Platform, View, Image } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'

import { useFormik } from 'formik'
import * as Yup from 'yup'
import utf8 from 'utf8'
import { Buffer } from 'buffer'
import delay from 'delay'

import client from '@sart/client'
import { useContent } from '@sart/content'
import { prettyErrorMessage, prettyErrorFromOrder, testID } from '@sart/utilities'
import { adaptive, backgroundColors, typography, colors } from '@sart/styles'

import {
  AnimatedEllipsis,
  Title,
  Text,
  Description,
  Space,
  Button,
  TextInputExtended,
  ReturnFooter,
  KeyboardAvoidingView,
  ButtonTitle
} from '@sart/components'
import { CompanyIcon } from '@sart/icons'

import NeedHelpFooter from '../NeedHelpFooter'
import * as theme from './signTheme'

const passwordRE = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=\S+$).{12,}$/

export default function SignUpSetPassword(props) {
  const content = useContent()

  const { navigation, route } = props

  const number = route.params?.number
  const email = route.params?.email
  const ncaFlow = route.params?.ncaFlow

  const formik = useFormik({
    initialValues: {
      password: '',
      passwordConfirmation: ''
    },
    validationSchema: Yup.object().shape({
      password: Yup.string()
        .matches(
          passwordRE,
          content.set_password.passwordRequirementsError
        )
        .required(content.forms.required),
      passwordConfirmation: Yup.string()
        .matches(
          passwordRE,
          content.set_password.passwordRequirementsError
        )
        .required(content.forms.required)
    }),
    onSubmit: handleUpdatePassword
  })

  async function handleUpdatePassword({ password, passwordConfirmation }, form) {
    Keyboard.dismiss()
    console.log('the email is: ' + email)
    if (password !== passwordConfirmation) {
      form.setFieldError(
        'passwordConfirmation',
        content.set_password.passwordsMatchError
      )
      return
    }

    form.setSubmitting(true)

    try {

      const params = {
        number,
        email,
        password
      }
      navigation.navigate('RegisterDetails', params)
    } catch (error) {
      console.log('In handleUpdatePassword')
      console.log('error is: ');
      console.log(error);
      if (error.response && error.response.body &&
        (error.response.body.messageCode === "SR00151" || error.response.body.code === 'REGISTRATION_INCOMPLETE')) {
        // we expect this at the minute - let them finish registration!
        const params = {
          userId,
          customerId,
          number,
          email
        }

        navigation.navigate('RegisterDetails', params)
      } else {
        const message = prettyErrorMessage(error, 'registration', content)

        form.setFieldError('passwordConfirmation', message)
        form.setSubmitting(false)
      }
    }
  }

  async function signUpNewCustomer(password, form) {
    let order
    try {

      order = await client.submitNCANoPaymentBasket()

      console.log('order 1 is: ');
      console.log(JSON.stringify(order, null, 2));

      await client.signInWithAgentUser({
        username: 'STANDALONE-SHOPPING-AGENT',
        password: 'Passw001'
      })

      order = await client.pollOrderForStatus(
        order.customerId,
        order.orderId
      )
      if (order.status === "successful") {
        console.log('order successful!')
        console.log(JSON.stringify(order, null, 2))
        client.unsetCache('existingSim')
        //await createTokenAndActivate(password, 0)
        navigation.navigate('RegisterNewCustomerConfirmation', { password, email, order })
      } else {
        // console.log('order failed')
        // console.log(JSON.stringify(order,null,2))
        const errorMessage = prettyErrorFromOrder(order, content)
        if (order && order.messageCode === "1002" || order.messageCode === "1003" || order.messageCode === "1004") {
          navigation.navigate('SignUpNewCustomerSim', { ncaErrorMessage: errorMessage })
        } else if (order && order.messageCode === "1") {
          form.setFieldError('passwordConfirmation', errorMessage)
        }
        else {
          console.log('Unexpected error code, sadge');
          console.log(order.messageCode);
        }
      }

    } catch (error) {
      console.log('In signUpNewCustomer')
      console.log('error is: ');
      console.log(error);
    }
  }

  var passwordRef;

  return (
    <SafeAreaView style={styles.container}>
      <KeyboardAvoidingView style={styles.content}>
        <View style={styles.logo}>
          <Image
            source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
            //height={styles.logoStyle.height} width={200} alignSelf={"center"}
            style={styles.logoImage}
          />
          {/* <CompanyIcon color={colors.white} height={styles.logoStyle.height} width={200} alignSelf={"center"} /> */}
        </View>
        <Space height={24} />

        <Title {...theme.title}>{content.set_password.title}</Title>

        <Space height={24} />

        <TextInputExtended
          allowShowHidePassword={true}
          label={content.set_password.passwordLabel}
          value={formik.values.password}
          placeholder={content.set_password.passwordLabel}
          {...Platform.select({
            web: { autoComplete: 'new-password' },
            ios: { textContentType: 'newPassword' },
            android: { autoCompleteType: 'password' }
          })}
          onChangeText={formik.handleChange('password')}
          onBlur={formik.handleBlur('password')}
          // footer={content.set_password.passwordRequirements}
          error={formik.touched.password && formik.errors.password}
          {...theme.textInput}
          onSubmitEditing={() => passwordRef.focus()}
          {...testID('SignUpRegisterPassword')}
        />

        <Space height={8} />

        <TextInputExtended
          allowShowHidePassword={true}
          label={content.set_password.passwordConfirmLabel}
          value={formik.values.passwordConfirmation}
          placeholder={content.set_password.passwordConfirmPlaceholder}
          {...Platform.select({
            web: { autoComplete: 'new-password' },
            ios: { textContentType: 'newPassword' },
            android: { autoCompleteType: 'password' }
          })}
          onChangeText={formik.handleChange('passwordConfirmation')}
          onBlur={formik.handleBlur('passwordConfirmation')}
          error={
            formik.touched.passwordConfirmation && formik.errors.passwordConfirmation
          }
          {...theme.textInput}
          // ref={ref => {
          //   passwordRef = ref;
          // }}
          onSubmitEditing={formik.handleSubmit}
          {...testID('SignUpRegisterPasswordRepeat')}
        />

        <Space height={48} />

        <Button
          title={
            formik.isSubmitting
              ? <ButtonTitle style={{ ...typography.extrabold, fontSize: 18, color: colors.white }}>{content.set_password.inProgress} <AnimatedEllipsis style={{ fontSize: 24, color: colors.srDarkGreen, ...typography.extrabold }} /></ButtonTitle>
              : content.set_password.action
          }
          disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
          onPress={formik.handleSubmit}
          {...theme.button}
          titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
          disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white + 45 }}
          {...testID('SignUpRegisterPasswordSubmit')}
        />
        {ncaFlow &&
          <ReturnFooter
            cancelStyle={styles.cancelStyle}
            title={content.common.cancel}
            onPress={() => navigation.navigate('SignUpNewCustomerSim')}
          />
        }
      </KeyboardAvoidingView>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 24,
    flex: 1,
    backgroundColor: backgroundColors.darkCharcoal,
    ...Platform.select({
      web: {
        alignItems: 'center'
      }
    })
  },
  content: {
    flex: 1,
    ...adaptive.wrapperPadding,
    //justifyContent: 'center',
    maxWidth: 600,
  },
  description: {
    textAlign: 'center'
  },
  cancelStyle: {
    color: colors.white
  },
  logo: {
    alignSelf: "center"
  },
  logoStyle: {
    ...adaptive.guruSize
  },
  logoImage: {
    height: 45,
    width: 45,
    position: 'relative',
    alignSelf: 'center',
    width: 200,
    ...adaptive.guruSize
  }
})
